import React, { useState, useEffect } from 'react';
import { COLORS } from './utils/constants.js';
import { useNotifications } from './hooks/useNotifications.js';
import { useAI } from './hooks/useAI.js';
import Header from './components/Header.jsx';
import TabNav from './components/TabNav.jsx';
import Notifications from './components/Notifications.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Prospect from './pages/Prospect.jsx';
import Contacts from './pages/Contacts.jsx';
import Companies from './pages/Companies.jsx';
import AITools from './pages/AITools.jsx';
import Campaigns from './pages/Campaigns.jsx';
import GetResponsePage from './pages/GetResponsePage.jsx';

export default function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [contacts, setContacts] = useState([]);
  const [sequences, setSequences] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [grConnected, setGrConnected] = useState(false);
  const { notifications, addNotification } = useNotifications();
  const ai = useAI(addNotification);

  const profile = {
    name: 'Lionel Mosley',
    email: 'connectwith@trust-lionel.com',
    title: 'IT Consultant',
    credits: 125,
    ai_credits: 5000,
    dial_credits: 160,
  };

  const pageProps = {
    profile,
    contacts,
    setContacts,
    sequences,
    selectedContact,
    setSelectedContact,
    grConnected,
    setGrConnected,
    addNotification,
    setActiveTab,
    ai,
  };

  const pages = {
    dashboard: Dashboard,
    prospect: Prospect,
    contacts: Contacts,
    companies: Companies,
    'ai-tools': AITools,
    campaigns: Campaigns,
    getresponse: GetResponsePage,
  };

  const ActivePage = pages[activeTab] || Dashboard;

  return (
    <div style={{ minHeight: '100vh', background: COLORS.bg, color: COLORS.text }}>
      <Notifications notifications={notifications} />
      <Header profile={profile} />
      <TabNav activeTab={activeTab} setActiveTab={setActiveTab} />
      <main style={{ padding: 24, maxWidth: 1400, margin: '0 auto', animation: 'fadeIn 0.3s ease' }}>
        <ActivePage {...pageProps} />
      </main>
      <footer
        style={{
          padding: '16px 24px',
          borderTop: `1px solid ${COLORS.border}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: 11,
          color: COLORS.textDim,
          fontFamily: "'Space Mono', monospace",
        }}
      >
        <span>SALESPORTAL v1.0 — Apollo + Claude AI + GetResponse</span>
        <span>Lionel Mosley · IT Consultant</span>
      </footer>
    </div>
  );
}
